import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appPhoneFormat]',
    standalone: true
})

export class PhoneFormatDirective {
    constructor(private el: ElementRef) { }
    @HostListener('input', ['$event'])
    onInput(event: any) {
        let inputValue = event.target.value.replace(/\D/g, '');
        let formattedValue = '';

        if (inputValue.length > 0) {
            formattedValue = `(${inputValue.substring(0, 3)}`;
        }

        if (inputValue.length > 3) {
            formattedValue = `${formattedValue}) ${inputValue.substring(3, 6)}`;
        }

        if (inputValue.length > 6) {
            formattedValue = `${formattedValue}-${inputValue.substring(6, 10)}`;
        }
        this.el.nativeElement.value = formattedValue;
    }
}